const M = (i, t) => {
    const s = i[t];
    return s ? typeof s == "function" ? s() : Promise.resolve(s) : new Promise((n, o) => {
      (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(o.bind(null, new Error("Unknown variable dynamic import: " + t)));
    });
  },
  ot = (i, t) => {
    var v, P, L, N;
    const s = i.document,
      n = t.userAgent.toLowerCase(),
      o = t.platform.toLowerCase(),
      r = n.includes("ipad") || n.includes("macintosh") && "ontouchend" in s,
      p = n.includes("iphone"),
      l = n.includes("ipod"),
      h = r || p || l,
      f = n.includes("android"),
      y = n.includes("windows phone"),
      D = o.startsWith("mac"),
      R = o.startsWith("win"),
      k = n.includes("webos"),
      b = n.includes("blackberry"),
      w = !!(i.ontouchstart || t.maxTouchPoints && t.maxTouchPoints > 0),
      T = n.includes("chrome") && n.includes("edge/"),
      S = !T && n.includes("chrome"),
      I = n.includes("firefox"),
      H = n.includes("msie") || t.appName === "Netscape" && n.includes("trident"),
      z = n.includes("webkit"),
      B = !!i.safari || ((v = t.vendor) == null ? void 0 : v.includes("Apple")) || !1,
      G = n.includes("rv:11.0"),
      W = n.includes("msie 10.0"),
      A = RegExp(/(?:version|chrome|firefox)\/(.*?)(?:$|\s)/).exec(n),
      q = A != null ? parseFloat(A[1]) : 0,
      E = h || f || y || b,
      F = !E,
      m = h || f || k || b || w,
      K = !m || w,
      V = i.devicePixelRatio !== void 0 && i.devicePixelRatio > 1,
      Y = m ? "tap" : "click",
      J = !m,
      Q = t.cookieEnabled,
      e = ((P = s.body.getAttribute("ww-app-variant")) == null ? void 0 : P.split(" ")) || ((L = s.documentElement.getAttribute("data-variant")) == null ? void 0 : L.split(" ")),
      u = decodeURIComponent(((N = RegExp("ww_da[^;]+").exec(s.cookie)) == null ? void 0 : N.toString().replace(/^[^=]+./, "")) || ""),
      X = !!e && e.indexOf("tablet") > -1,
      Z = !!e && e.indexOf("phone") > -1,
      _ = !!e && e.indexOf("ios") > -1,
      x = !!e && e.indexOf("android") > -1,
      tt = s.documentElement.dataset.upeDeviceType === "app" || _ || x,
      nt = u && u !== "undefined" || !!e && e.indexOf("desktopapp") > -1,
      it = u === "other" || !!e && e.indexOf("electron") > -1,
      st = !!e && e.indexOf("zoomapp") > -1;
    return {
      ios: h,
      android: f,
      windowsPhone: y,
      mac: D,
      windows: R,
      webos: k,
      blackberry: b,
      windowsTouch: w,
      edge: T,
      chrome: S,
      firefox: I,
      ie: H,
      webkit: z,
      safari: B,
      ie11: G,
      ie10: W,
      version: q,
      mobile: E,
      desktop: F,
      touchable: m,
      mousable: K,
      retina: V,
      clickGesture: Y,
      dragFile: J,
      cookies: Q,
      tablet: X,
      phone: Z,
      iosApp: _,
      androidApp: x,
      app: tt,
      desktopApp: nt,
      nwjs: u === "nwjs",
      electronApp: it,
      zoomApp: st
    };
  },
  et = ot(window, navigator),
  O = navigator.language,
  rt = (() => {
    var i;
    return et.app ? ((i = new URLSearchParams(window.location.search).get("locale")) == null ? void 0 : i.replace("_", "-")) || O : document.documentElement.lang || O;
  })(),
  d = "en";
let c = {},
  a = d,
  j = {};
const $ = () => {
    let i = {};
    if (a !== d) {
      if (c[a]) i = c[a];else if (a.includes("-")) {
        const t = a.split("-").shift(),
          s = Object.keys(c);
        for (const n of s) if (n.split("-").shift() === t) {
          i = c[n];
          break;
        }
      }
    }
    j = i;
  },
  at = i => {
    a = i.replace("_", "-"), $();
  },
  lt = async () => {
    var i;
    Object.keys(j).length === 0 && (at(rt), c = (i = window.$upe_intl) != null ? i : {}, $());
  },
  ct = async i => {
    let t;
    try {
      t = await M( /* @__PURE__ */Object.assign({
        "../../intl/translations/_e.json": () => import("./_e.ilfUA8oL.js"),
        "../../intl/translations/ar.json": () => import("./ar.a88dT_Ch.js"),
        "../../intl/translations/bg.json": () => import("./bg.hqnwEHRi.js"),
        "../../intl/translations/bn.json": () => import("./bn.V7W_-Ehd.js"),
        "../../intl/translations/ca.json": () => import("./ca.RTQ0Cp0g.js"),
        "../../intl/translations/cs.json": () => import("./cs.oLZ9USHV.js"),
        "../../intl/translations/cy.json": () => import("./cy.nDcPSklY.js"),
        "../../intl/translations/da.json": () => import("./da.SwfPr14G.js"),
        "../../intl/translations/de.json": () => import("./de.zox4LLU-.js"),
        "../../intl/translations/el.json": () => import("./el.4M3z5RTl.js"),
        "../../intl/translations/en_GB.json": () => import("./en_GB.TTp5kR3Q.js"),
        "../../intl/translations/es.json": () => import("./es.DoaURoo9.js"),
        "../../intl/translations/et.json": () => import("./et.Qv-vZSrN.js"),
        "../../intl/translations/fa.json": () => import("./fa.E2uffGN_.js"),
        "../../intl/translations/fi.json": () => import("./fi.QYaaJx8Q.js"),
        "../../intl/translations/fr.json": () => import("./fr.kXigQ_HG.js"),
        "../../intl/translations/gl_ES.json": () => import("./gl_ES.yNg0r8BQ.js"),
        "../../intl/translations/he.json": () => import("./he.1d1JIAAJ.js"),
        "../../intl/translations/hi.json": () => import("./hi.-9yNTfty.js"),
        "../../intl/translations/hr.json": () => import("./hr.gi1Fy1jO.js"),
        "../../intl/translations/hu.json": () => import("./hu.uEZbnw8f.js"),
        "../../intl/translations/id.json": () => import("./id.6P2s640k.js"),
        "../../intl/translations/it.json": () => import("./it.Szd57HHf.js"),
        "../../intl/translations/ja.json": () => import("./ja.WlYg7Vbf.js"),
        "../../intl/translations/ko.json": () => import("./ko.sK5_UKLH.js"),
        "../../intl/translations/lv.json": () => import("./lv.GQTjPamq.js"),
        "../../intl/translations/ms.json": () => import("./ms.48eZrPkv.js"),
        "../../intl/translations/nl.json": () => import("./nl.cc0npy-k.js"),
        "../../intl/translations/no.json": () => import("./no.Jz5OCjWg.js"),
        "../../intl/translations/pl.json": () => import("./pl.xk-4gl1v.js"),
        "../../intl/translations/pt_BR.json": () => import("./pt_BR.x_PtBjFp.js"),
        "../../intl/translations/ro.json": () => import("./ro.bJpgm6En.js"),
        "../../intl/translations/ru.json": () => import("./ru.lX4J8R0k.js"),
        "../../intl/translations/sk.json": () => import("./sk.G-YqlEx-.js"),
        "../../intl/translations/sr.json": () => import("./sr.ugDiwE1f.js"),
        "../../intl/translations/sv.json": () => import("./sv.ESCCFLQJ.js"),
        "../../intl/translations/th.json": () => import("./th.-aDjhfmG.js"),
        "../../intl/translations/tl.json": () => import("./tl.AAlvWX9s.js"),
        "../../intl/translations/tr.json": () => import("./tr.19XOvOk5.js"),
        "../../intl/translations/uk.json": () => import("./uk.Uq48ZKAq.js"),
        "../../intl/translations/ur.json": () => import("./ur._Jk0_c9s.js"),
        "../../intl/translations/vi.json": () => import("./vi.AJN9w4YU.js"),
        "../../intl/translations/zh_CN.json": () => import("./zh_CN.GCSABdTC.js"),
        "../../intl/translations/zh_TW.json": () => import("./zh_TW.ZSz9QUY4.js")
      }), `../../intl/translations/${i.replace("-", "_")}.json`);
    } catch (s) {
      try {
        t = await M( /* @__PURE__ */Object.assign({
          "../../intl/translations/_e.json": () => import("./_e.ilfUA8oL.js"),
          "../../intl/translations/ar.json": () => import("./ar.a88dT_Ch.js"),
          "../../intl/translations/bg.json": () => import("./bg.hqnwEHRi.js"),
          "../../intl/translations/bn.json": () => import("./bn.V7W_-Ehd.js"),
          "../../intl/translations/ca.json": () => import("./ca.RTQ0Cp0g.js"),
          "../../intl/translations/cs.json": () => import("./cs.oLZ9USHV.js"),
          "../../intl/translations/cy.json": () => import("./cy.nDcPSklY.js"),
          "../../intl/translations/da.json": () => import("./da.SwfPr14G.js"),
          "../../intl/translations/de.json": () => import("./de.zox4LLU-.js"),
          "../../intl/translations/el.json": () => import("./el.4M3z5RTl.js"),
          "../../intl/translations/en_GB.json": () => import("./en_GB.TTp5kR3Q.js"),
          "../../intl/translations/es.json": () => import("./es.DoaURoo9.js"),
          "../../intl/translations/et.json": () => import("./et.Qv-vZSrN.js"),
          "../../intl/translations/fa.json": () => import("./fa.E2uffGN_.js"),
          "../../intl/translations/fi.json": () => import("./fi.QYaaJx8Q.js"),
          "../../intl/translations/fr.json": () => import("./fr.kXigQ_HG.js"),
          "../../intl/translations/gl_ES.json": () => import("./gl_ES.yNg0r8BQ.js"),
          "../../intl/translations/he.json": () => import("./he.1d1JIAAJ.js"),
          "../../intl/translations/hi.json": () => import("./hi.-9yNTfty.js"),
          "../../intl/translations/hr.json": () => import("./hr.gi1Fy1jO.js"),
          "../../intl/translations/hu.json": () => import("./hu.uEZbnw8f.js"),
          "../../intl/translations/id.json": () => import("./id.6P2s640k.js"),
          "../../intl/translations/it.json": () => import("./it.Szd57HHf.js"),
          "../../intl/translations/ja.json": () => import("./ja.WlYg7Vbf.js"),
          "../../intl/translations/ko.json": () => import("./ko.sK5_UKLH.js"),
          "../../intl/translations/lv.json": () => import("./lv.GQTjPamq.js"),
          "../../intl/translations/ms.json": () => import("./ms.48eZrPkv.js"),
          "../../intl/translations/nl.json": () => import("./nl.cc0npy-k.js"),
          "../../intl/translations/no.json": () => import("./no.Jz5OCjWg.js"),
          "../../intl/translations/pl.json": () => import("./pl.xk-4gl1v.js"),
          "../../intl/translations/pt_BR.json": () => import("./pt_BR.x_PtBjFp.js"),
          "../../intl/translations/ro.json": () => import("./ro.bJpgm6En.js"),
          "../../intl/translations/ru.json": () => import("./ru.lX4J8R0k.js"),
          "../../intl/translations/sk.json": () => import("./sk.G-YqlEx-.js"),
          "../../intl/translations/sr.json": () => import("./sr.ugDiwE1f.js"),
          "../../intl/translations/sv.json": () => import("./sv.ESCCFLQJ.js"),
          "../../intl/translations/th.json": () => import("./th.-aDjhfmG.js"),
          "../../intl/translations/tl.json": () => import("./tl.AAlvWX9s.js"),
          "../../intl/translations/tr.json": () => import("./tr.19XOvOk5.js"),
          "../../intl/translations/uk.json": () => import("./uk.Uq48ZKAq.js"),
          "../../intl/translations/ur.json": () => import("./ur._Jk0_c9s.js"),
          "../../intl/translations/vi.json": () => import("./vi.AJN9w4YU.js"),
          "../../intl/translations/zh_CN.json": () => import("./zh_CN.GCSABdTC.js"),
          "../../intl/translations/zh_TW.json": () => import("./zh_TW.ZSz9QUY4.js")
        }), `../../intl/translations/${i.split("-").shift()}.json`);
      } catch (n) {}
    }
    return t == null ? void 0 : t.default;
  },
  ht = async i => {
    const t = await ct(i);
    t != null && (window.$upe_intl = {
      [i]: t
    });
  },
  U = (i, t) => t ? i.replace(/%?\{(.*?)}/g, (s, n) => t[n] === void 0 || t[n] === null ? s : t[n]) : i,
  pt = (i, t) => {
    lt();
    let s = i;
    if (a !== d) {
      const n = j[i];
      n && (s = n);
    }
    return U(s, t);
  },
  mt = i => {
    let t = i.phrase;
    return t || (t = `{COUNT, plural, one {${i.singularPhrase}} other {${i.pluralPhrase}}}`), i.context && (t = i.context + "|" + t), t;
  },
  ft = (i, t, s) => {
    let n = t;
    if (a !== d) {
      const o = mt({
          context: i,
          phrase: t
        }),
        r = j[o];
      r && (n = r);
    }
    return U(n, s);
  },
  C = "pdlt-mention",
  ut = ["user"];
class g extends HTMLElement {
  /**
   * Create a new PdltMention element from a set of attributes.
   */
  static fromAttributes(_ref) {
    let {
      type: t,
      mentioner: s,
      mentionee: n
    } = _ref;
    if (window.customElements.get(C) == null) throw Error("PdltMention is not registered yet");
    const o = new g();
    return o.setAttribute("type", t), o.setAttribute("mentioner-id", s.hashid), o.setAttribute("mentionee-id", n.hashid), o.setAttribute("mentionee-username", n.username), o.textContent = n.display_name, o;
  }
  /**
   * Create a new PdltMention element from an HTML string.
   */
  static fromString(t) {
    if (window.customElements.get(C) == null) throw Error("PdltMention is not registered yet");
    const s = document.createElement("template");
    if (s.innerHTML = t, s.innerHTML !== t) return null;
    const n = s.content.firstElementChild;
    if (n === null) return null;
    const o = {
        type: n.getAttribute("type"),
        "mentioner-id": n.getAttribute("mentioner-id"),
        "mentionee-id": n.getAttribute("mentionee-id"),
        "mentionee-username": n.getAttribute("mentionee-username"),
        mentioneeDisplayName: n.textContent
      },
      r = new g();
    return Object.entries(o).forEach(_ref2 => {
      let [p, l] = _ref2;
      p === "mentioneeDisplayName" ? l !== null && (r.textContent = l) : l !== null && r.setAttribute(p, l);
    }), r;
  }
  get isValid() {
    return this.type === "user" ? this.mentionerId !== null && this.mentioneeId !== null && this.mentioneeUsername !== null && this.mentioneeDisplayName !== "" : !1;
  }
  get type() {
    const t = this.getAttribute("type");
    if (t === null) return null;
    const s = t;
    return ut.includes(s) ? s : null;
  }
  get mentionerId() {
    return this.getAttribute("mentioner-id");
  }
  get mentioneeId() {
    return this.getAttribute("mentionee-id");
  }
  get mentioneeUsername() {
    return this.getAttribute("mentionee-username");
  }
  get mentioneeDisplayName() {
    return this.textContent;
  }
  toString() {
    return this.outerHTML;
  }
  connectedCallback() {
    this.type === "user" && this.renderProfileLink();
  }
  renderProfileLink() {
    var t;
    if (this.mentioneeUsername != null && this.mentioneeUsername !== "") {
      const s = `https://${window.location.hostname}/${this.mentioneeUsername}`;
      this.innerHTML = `<a href="${s}" target="_blank" data-bridged-link="profile" data-bridged-link-username="${this.mentioneeUsername}">${(t = this.mentioneeDisplayName) != null ? t : pt("Someone")}</a>`;
    }
  }
}
export { C as M, g as P, et as d, rt as h, ht as i, ft as p, pt as t };